const {Howl} = require('howler');

export const Sound = {
    stop: process.env.PUBLIC_URL + "/sound/stop.wav",
    next: process.env.PUBLIC_URL + "/sound/next.wav",
    thank: process.env.PUBLIC_URL + "/sound/thank_you.wav",
    awhman: process.env.PUBLIC_URL + "/sound/awh_man.wav",
    warning: process.env.PUBLIC_URL + "/sound/warning.mp3"
}

export function play(sound) {
        var sound = new Howl({
            src: [sound]
        });
        sound.play();
}